import {HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {IEntityLocation} from '@entities/entity-location/entity-location.model';
import {EntityLocationSearch} from '@entities/entity-location/entity-location.search';
import {EntityLocationService} from '@entities/entity-location/entity-location.service';

@Injectable({
  providedIn: 'root',
})
export class EntityLocationsResolve implements Resolve<any[]> {
  private searchService: EntityLocationSearch;
  constructor(private service: EntityLocationService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any> | Promise<any> | any {
    const entityId = route.params['id'] ? route.params['id'] : null;

    this.searchService = new EntityLocationSearch();
    this.searchService.entityId.filterValue = entityId;
    this.searchService.setActivatedRouteData(route);

    const filterParams = this.searchService.getFilterParams();
    this.searchService.setQueryParams(filterParams);

    const req = this.searchService.getParams();

    return this.service
      .query(req)
      .pipe(map((res: HttpResponse<IEntityLocation[]>) => res.body));
  }
}
